<template>
    <div>
        <div class="feature-backdrop">
            <font-awesome-icon class="mr-2" icon="clipboard-list"></font-awesome-icon>
            Sign Ups
        </div>
        <b-skeleton-wrapper :loading="loading">
            <template #loading>
                <b-card class="mt-2">
                    <b-skeleton width="85%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                </b-card>
            </template>
            <table class="table-content w-100">
                <tr>
                    <th>
                        Details
                    </th>
                    <th>
                        Status
                    </th>
                    <th>
                        Action
                    </th>
                </tr>
                <tr
                    v-for="(signup, idx) in signups"
                    v-bind:key="idx"
                >
                    <td>
                        <h5>{{ signup.name }}</h5>
                        <h6 v-if="signup.locked" class="text-dark">
                            <font-awesome-icon icon="lock" class="mr-2"></font-awesome-icon>
                            <em>Locked</em>
                        </h6>
                        <h6 v-else-if="signup.expires" class="text-muted">
                            <i>Sign-up closes {{ $moment(signup.expires).local().format('LLLL') }}</i>
                        </h6>
                        <div>
                            {{ signup.description }}
                        </div>
                    </td>
                    <td>
                        <span v-if="signup.isMember" class="text-success">
                            <font-awesome-icon icon="check-circle"></font-awesome-icon>
                            Signed up
                        </span>
                        <span
                            v-else
                            class="text-danger"
                        >
                            <font-awesome-icon icon="times-circle"></font-awesome-icon>
                            Not signed up
                        </span>
                    </td>
                    <td>
                        <div class="text-center">
                            <router-link
                                class="sc-btn pill"
                                :to="{ name: 'single_signup', params: { id: signup.id } }"
                            >
                                {{ (signup.isMember) ? "View Sign-up" : "Sign up" }} <font-awesome-icon icon="arrow-circle-right" class="ml-1"></font-awesome-icon>
                            </router-link>
                        </div>
                    </td>
                </tr>
                <tr v-if="!signups.length" class="table-info-message">
                    <td colspan="3">
                        <font-awesome-icon icon="info-circle" class="mr-1"></font-awesome-icon>
                        <em>There are no sign-ups to display at this time.</em>
                    </td>
                </tr>
            </table>
        </b-skeleton-wrapper>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: ['tag', 'id'],
    data: function () {
        return {
            results : [],
            signups : [],
            loading : false,
            loaded  : false
        };
    },
    methods: {
        loadSignups() {
            this.loading = true;
            this.$api.get(`/api/sign-ups/list`).then((response) => {
                this.signups = response.data.signups;
                this.loading = false;
                this.loaded  = true;
            });
        }
    },
    mounted () {
        this.loadSignups();
    },
    computed: mapState(['user'])
}
</script>